import { FilterActions } from '../constants/filter/filter_actions';
import Dispatcher from '../dispatcher';

function openSectionContentsAction(payload) {
    Dispatcher.handleCatalogFilterLightboxViewAction({ type: FilterActions.OPEN_LIGHTBOX_FILTER_SECTION, payload });
}

function closeSectionContentsAction() {
    Dispatcher.handleCatalogFilterLightboxViewAction({ type: FilterActions.CLOSE_LIGHTBOX_FILTER_SECTION });
}

export {
    openSectionContentsAction,
    closeSectionContentsAction
};